import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { DashboardTopCustomerResponse } from "types/dashboard-top-customer";

interface UseAllTopCustomerParams {
    start_date?: string;
    end_date?: string;
}

interface GetAllTopCustomer extends AxiosResponse {
    data: DashboardTopCustomerResponse
}

const useTopCustomer = (params: UseAllTopCustomerParams) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    const queryParams = new URLSearchParams(params as unknown as Record<string, string>).toString();

    return useQuery<unknown, unknown, GetAllTopCustomer>({
        queryKey: ['get-all-top-customer'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/top/customer?${queryParams}`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useTopCustomer;